/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Field_DeadlineInputs */

const en_task_field_deadline = /** @type {(inputs: Task_Field_DeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deadline`)
};

const pt_br2_task_field_deadline = /** @type {(inputs: Task_Field_DeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prazo`)
};

/**
* | output |
* | --- |
* | "Deadline" |
*
* @param {Task_Field_DeadlineInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_field_deadline = /** @type {((inputs?: Task_Field_DeadlineInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Field_DeadlineInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_field_deadline(inputs)
	return pt_br2_task_field_deadline(inputs)
});